<template>
<layout-base :title="$t('STEP_TWO.TITLE')">
  <template slot="content">
  <bk-select
    class="select"
    :fields="countryList"
    :value="country"
    :label="$t('STEP_TWO.COUNTRY')"
    @input="changeCountry"
    id="country-select"
    :valid="true"
    :pristine="false"
  />
  <bk-place
    :label="$t('STEP_TWO.ZIP_OR_PLACE')"
    :helper-text="$t('STEP_TWO.COUNTRY_HELPER_TEXT')"
    :country="country"
    :initialCity="city"
    :initialGeoId="geoId"
    @change="changePlace"
    :valid="geoIdValid"
    id="placesearch"
    :allow-hotjar-recording="true"
  />

  <bk-birthdate :birthdate="birthdate" @change="changeBirthdate" :valid="birthdateValid" />

  </template>
  <template slot="buttons">
  <bk-button @click="navigate"
             :disabled="country.isEmpty() || !geoIdValid || !birthdateValid"
  >{{$t('GLOBAL.CONTINUE')}}
  </bk-button>
  <bk-back-button track-action="Schritt2" track-label="Zurueck" to="/" />
  </template>
  <template slot="usp">
    <coupon-box v-if="!coupon.isEmpty()"/>
  </template>
</layout-base>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import moment from 'moment/moment'
import LayoutBase from './LayoutBase'
import BkPlace from '../components/Place'
import BkBirthdate from '../components/Birthdate'
import SelectFieldMixin from '../../../mixins/selectField'
import { stepTwoGuard } from '../guards'
import BkSelect from '../../../common/BkSelect'
import BkButton from '../../../common/BkButton'
import BkBackButton from '../../../common/BkBackButton'
import EventTrigger from '../../../mixins/triggerEvent'
import CouponBox from '../components/CouponBox'

export default {
  components: {
    BkBirthdate,
    BkPlace,
    LayoutBase,
    BkSelect,
    BkButton,
    BkBackButton,
    CouponBox
  },
  beforeRouteEnter: stepTwoGuard,
  data () {
    return {
      /**
       * The selected country
       * Default is Germany
       */
      country: 'D',
      placesearchId: 'placesearchId',
    }
  },
  computed: {
    ...mapState(['birthdate', 'geoId', 'city', 'coupon']),
    /**
     * get a list of the country with a shorthand as value and the translated name as name
     * @returns {{name: string, value: string}[]}
     */
    countryList () {
      return [
        this.createSelectField('D', this.$i18n.t('STEP_TWO.GERMANY')),
        this.createSelectField('A', this.$i18n.t('STEP_TWO.AUSTRIA')),
        this.createSelectField('CH', this.$i18n.t('STEP_TWO.SWITZERLAND')),
        this.createSelectField('PL', this.$i18n.t('STEP_TWO.POLAND')),
      ]
    },
    birthdateValid () {
      if (this.birthdate.isNaN) return false

      const date = moment(this.birthdate, 'YYYY-MM-DD')
      const years = moment().diff(date, 'year')
      return years >= 18
    },
    geoIdValid () {
      return this.geoId > 0
    }
  },
  methods: {
    ...mapMutations(['updateBirthdateState', 'updateBirthdate', 'updateGeoId', 'updateCity']),
    /**
     * Navigate to the next step if all fields are valid
     */
    navigate () {
      this.triggerInputEvent(this.placesearchId)
      this.triggerSelect('birthdate_day')

      this.$router.push('step-three')
      this.fireTrackEvent('Schritt2', 'Abgeschlossen')

    },
    /**
     * update the birthdate of the user
     *
     * @param date
     */
    changeBirthdate (date) {
      this.updateBirthdate(date)
    },
    /**
     * update the geoId and the city of the user
     * @param value
     */
    changePlace (value) {
      this.updateGeoId(0)
      this.updateCity(value.city)
      this.updateGeoId(value.geoId)
    },
    /**
     * Change the country
     * @param value
     */
    changeCountry (value) {
      this.country = value
      this.updateGeoId(0)
      this.updateCity('')
    },
  },
  mixins: [SelectFieldMixin, EventTrigger],

}
</script>

<style lang="scss" scoped>
  .bk-reg-input {
    margin-bottom: 16px;
  }

  .select {
    margin-bottom: 16px;
  }
</style>
